import Vue2Filters from 'vue2-filters'

const FiltersPlugin = {
    install(Vue) {
        Vue.use(Vue2Filters)
    },
}

export default FiltersPlugin
